export default __webpack_public_path__ + "static/media/794.aa4b38b6.png";